/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetReportsSalesForecastQueryResponse,
  GetReportsSalesForecastQueryParams,
  GetReportsSalesForecast400,
} from '../../types/GetReportsSalesForecast'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getReportsSalesForecast } from '../../clients/getReportsSalesForecast'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getReportsSalesForecastQueryKey = (
  params: GetReportsSalesForecastQueryParams
) =>
  [
    { url: '/api/v1/reports/dashboard/sales-forecast/' },
    ...(params ? [params] : []),
  ] as const

export type GetReportsSalesForecastQueryKey = ReturnType<
  typeof getReportsSalesForecastQueryKey
>

export function getReportsSalesForecastQueryOptions(
  params: GetReportsSalesForecastQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getReportsSalesForecastQueryKey(params)
  return queryOptions<
    GetReportsSalesForecastQueryResponse,
    ResponseErrorConfig<GetReportsSalesForecast400>,
    GetReportsSalesForecastQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return getReportsSalesForecast(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @description Forecasted revenue/volume by month plus summary cards, filtered to active (non closed-lost) deals with a resolvable close date. Returns 400 (empty body) when time_horizon is supplied but isn't one of 12/24/36.
 * @summary Reports dashboard sales forecast
 * {@link /api/v1/reports/dashboard/sales-forecast/}
 */
export function useGetReportsSalesForecast<
  TData = GetReportsSalesForecastQueryResponse,
  TQueryData = GetReportsSalesForecastQueryResponse,
  TQueryKey extends QueryKey = GetReportsSalesForecastQueryKey,
>(
  params: GetReportsSalesForecastQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetReportsSalesForecastQueryResponse,
        ResponseErrorConfig<GetReportsSalesForecast400>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? getReportsSalesForecastQueryKey(params)

  const query = useQuery(
    {
      ...getReportsSalesForecastQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetReportsSalesForecast400>
  > & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}
